type DispatcherNameSource = {
    name?: string | null
    email?: string | null
    firstName?: string | null
    lastName?: string | null
    fullName?: string | null
    googleProfile?: { name?: string | null } | null
    outlookProfile?: { name?: string | null } | null
}

const normalize = (value?: string | null): string => value?.replace(/\s+/g, ' ').trim() || ''

/**
 * Resolves a user-facing dispatcher name while supporting multiple payload shapes.
 * Priority: fullName -> firstName + lastName -> google/outlook profile name -> name -> email.
 */
export const getDispatcherDisplayName = (dispatcher?: DispatcherNameSource | null, fallback = 'Unknown Dispatcher'): string => {
    if (!dispatcher) return fallback

    const fullName = normalize(dispatcher.fullName)
    if (fullName) return fullName

    const joinedParts = normalize([normalize(dispatcher.firstName), normalize(dispatcher.lastName)].filter(Boolean).join(' '))
    if (joinedParts) return joinedParts

    const oauthProfileName = normalize(dispatcher.googleProfile?.name) || normalize(dispatcher.outlookProfile?.name)
    if (oauthProfileName) return oauthProfileName

    const name = normalize(dispatcher.name)
    if (name) return name

    const email = normalize(dispatcher.email)
    return email || fallback
}
